import React from "react";

// Example Data ===============>
//  {
//     key:"uniqueKey",
//     path: "/login",
//     type: "public"||"protected"||"auth",
//     component: React.lazy(() => import("../pages/auth/Login")),
//     layouts: "auth"||"default"||false,
//     disabled:true||false,
//     title: "page title",
//     subRoute: [
//       {
//         key:"uniqueKey",
//         path: "manage",
//         type: "protected",
//         component: React.lazy(() => import("../pages/employees/Manage")),
//         layouts: "auth"||"default"||false,
//         disabled:true||false,
//         title: "page title",
//       },
//     ],
//  }

const authRoute = (data) => {
  return [
    {
      path: "/login",
      type: "auth",
      component: React.lazy(() => import("../pages/auth/Login")),
      layouts: "auth",
      title: "log",
    },
  ];
};

const publicRoute = (data) => {
  return [
    {
      path: "/",
      type: "public",
      component: React.lazy(() => import("../pages/home/index")),
      layouts: false,
      title: "Home",
    },
  ];
};

const protectedRoute = (data) => {
  return [
    {
      path: "/dashboard",
      type: "protected",
      component: React.lazy(() => import("../pages/company/Dashboard")),
      layouts: "default",
      title: "admin-dashboard",
    },
    {
      path: "/admin/dashboard",
      type: "protected",
      component: React.lazy(() => import("../pages/admin/Dashboard")),
      layouts: "default",
      title: "company-dashboard",
    },
    {
      path: "/profile",
      type: "protected",
      component: React.lazy(() => import("../pages/company/AdminProfile")),
      layouts: "default",
    },
    {
      path: "/settings",
      type: "protected",
      component: React.lazy(() => import("../pages/company/Settings")),
      layouts: "default",
    },
    {
      path: "/notification",
      type: "protected",
      component: React.lazy(() => import("../pages/company/Notification")),
      layouts: "default",
    },
    {
      path: "/admins",
      type: "protected",
      component: React.lazy(() => import("../pages/company/Admins")),
      layouts: "default",
    },
    {
      path: "/users",
      type: "protected",
      component: React.lazy(() => import("../pages/company/Users")),
      layouts: "default",
    },
    {
      path: "/employees",
      type: "protected",
      component: React.lazy(() => import("../pages/company/employees/List")),
      layouts: "default",
      subRoute: [
        {
          path: "manage",
          type: "protected",
          component: React.lazy(() =>
            import("../pages/company/employees/Manage")
          ),
          layouts: "default",
        },
      ],
    },
    {
      path: "/services",
      type: "protected",
      component: React.lazy(() => import("../pages/company/Services")),
      layouts: "default",
    },
  ];
};

export const routerData = (userData) => [
  ...publicRoute(userData),
  ...authRoute(userData),
  ...protectedRoute(userData),
];
